module.exports = __webpack_public_path__ + "r-v3/img/menu_screenshare_white.b412bb8c.svg";